import moment from "moment";

export const groupData = (data, dateRange) => {
  if (!data || !data.xAxis || !data.yAxis) {
    return data;
  }

  const label = dateRange[0]?.label || "";
  let grouped = { xAxis: data.xAxis, yAxis: data.yAxis };

  if (label === "Last 12 Months" || label === "This Year") {
    const temp = {};
    data.xAxis.forEach((date, index) => {
      const month = moment(date).format("MMM");
      if (!temp[month]) temp[month] = 0;
      temp[month] += Number(data.yAxis[index]) || 0;
    });
    grouped = { xAxis: Object.keys(temp), yAxis: Object.values(temp) };
  } else if (label === "Last Month" || label === "This Quarter") {
    const temp = {};
    data.xAxis.forEach((date, index) => {
      const week = moment(date).format("YYYY-[W]WW");
      if (!temp[week]) temp[week] = 0;
      temp[week] += Number(data.yAxis[index]) || 0;
    });
    grouped = { xAxis: Object.keys(temp), yAxis: Object.values(temp) };
  }

  const formattedXAxis = grouped.xAxis.map((date) => {
    if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return moment(date).format("MMM DD");
    }
    return date;
  });

  return {
    ...data,
    xAxis: formattedXAxis,
    yAxis: grouped.yAxis,
  };
};

export default groupData;
